import type { ApiClient } from '../../core/api-client.js';
import { ApiError } from '../../core/api-client.js';
import type { Resultado } from '../../core/resultado.js';
import type { Ticket, NovoTicket, FiltroTicket } from '@pgcustom/shared-types';

/**
 * Adapter do módulo Suporte no frontend — único ponto que conhece o
 * formato das rotas `/api/v1/suporte/*`
 * (`apps/api/src/modules/suporte/suporte.routes.ts`). "Acionar
 * garantia" (`PRODUCT.md` 3.7) é criar um ticket com `garantiaId`
 * preenchido — sem endpoint separado.
 */
export class SuporteApi {
  constructor(private readonly api: ApiClient) {}

  async listar(filtro: FiltroTicket = {}): Promise<Resultado<Ticket[]>> {
    try {
      const resposta = await this.api.get<{ tickets: Ticket[] }>('/suporte', { ...filtro });
      if (resposta.tickets.length === 0) return { status: 'vazio' };
      return { status: 'ok', dado: resposta.tickets };
    } catch (erro) {
      if (erro instanceof ApiError && erro.status === 403) return { status: 'sem-permissao' };
      return { status: 'erro', mensagem: erro instanceof ApiError ? erro.message : 'falha ao carregar tickets' };
    }
  }

  async criar(dado: NovoTicket): Promise<Ticket> {
    const resposta = await this.api.post<{ ticket: Ticket }>('/suporte', dado);
    return resposta.ticket;
  }

  async fechar(id: string): Promise<Ticket> {
    const resposta = await this.api.post<{ ticket: Ticket }>(`/suporte/${id}/fechar`, {});
    return resposta.ticket;
  }
}
